import {
  ADD_WHITE_LIST,
  ADD_WHITE_LIST_SUCCESS,
  ADMIN_GET_MISSION_BY_ID,
  ADMIN_GET_MISSION_BY_ID_SUCCESS,
  ADMIN_REPORT,
  ADMIN_REPORT_SUCEESS,
  CHANGE_ACCOUNT_STATUS,
  CHANGE_ACCOUNT_STATUS_SUCCESS,
  CHANGE_ADDRESS,
  CHANGE_ADDRESS_SUCCESS,
  CHANGE_ETC_MISSING_STATUS,
  CHANGE_ETC_MISSING_STATUS_SUCCESS,
  CHANGE_MISSING_STATUS,
  CHANGE_MISSING_STATUS_SUCCESS,
  CHANGE_ROLE,
  CHANGE_ROLE_SUCCESS,
  DELETE_EVENT,
  DELETE_EVENT_SUCEESS,
  GET_ADMIN_FOUND,
  GET_ADMIN_FOUND_SUCCESS,
  GET_ADMIN_MISSING,
  GET_ADMIN_MISSING_SUCCESS,
  GET_ETC_MISSING,
  GET_ETC_MISSING_SUCCESS,
  GET_FOUND,
  GET_FOUND_SUCCESS,
  GET_LOG,
  GET_LOG_SUCCESS,
  GET_MISSING,
  GET_MISSING_SUCCESS,
  GET_SETTING,
  GET_SETTING_SUCCESS,
  GET_USER,
  GET_USER_SUCCESS,
  GET_WHITE_LIST,
  GET_WHITE_LIST_SUCCESS,
  HIDE_ADMIN_MESSAGE,
  ON_HIDE_ADMIN_LOADER,
  ON_SHOW_ADMIN_LOADER,
  ON_UPDATE_Missing,
  ON_UPDATE_Missing_Success,
  REMOVE_WHITE_LIST,
  REMOVE_WHITE_LIST_SUCCESS,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  SHOW_ADMIN_MESSAGE,
  UPDATE_SETTING,
  UPDATE_SETTING_SUCCESS,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  loader: false,
  alertMessage: "",
  showMessage: false,
  users: [],
  adminMissings: [],
  adminEtcMissings: [],
  adminFounds: [],
  setting: null,
  logs: null,
  whiteList: [],
  loaderUpsertWhiteList: false,
  loadOperation: false,
  changeAddressSuccess: false,
  adminReport: null,
  missionData: null,
  getMissionLoader: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USER: {
      let userList = state.users;
      if (action?.payload?.forceReresh) {
        userList = [];
      }
      return {
        ...state,
        //loader: true,
        users: userList,
      };
    }
    case GET_LOG: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_LOG_SUCCESS: {
      return {
        ...state,
        loader: false,
        logs: action.payload,
      };
    }
    case ADD_WHITE_LIST: {
      return {
        ...state,
        loaderUpsertWhiteList: true,
      };
    }
    case ADD_WHITE_LIST_SUCCESS: {
      return {
        ...state,
        loaderUpsertWhiteList: false,
      };
    }
    case REMOVE_WHITE_LIST: {
      return {
        ...state,
        loaderUpsertWhiteList: true,
      };
    }
    case REMOVE_WHITE_LIST_SUCCESS: {
      return {
        ...state,
        loaderUpsertWhiteList: false,
      };
    }
    case GET_WHITE_LIST: {
      let whiteList = state.whiteList;
      if (action?.payload?.forceReresh) {
        whiteList = [];
      }
      return {
        ...state,
        loader: true,
        whiteList: whiteList,
      };
    }

    case GET_WHITE_LIST_SUCCESS: {
      return {
        ...state,
        loader: false,
        whiteList: action.payload,
      };
    }

    case CHANGE_ACCOUNT_STATUS: {
      return {
        ...state,
        loadOperation: true,
      };
    }
    case CHANGE_ACCOUNT_STATUS_SUCCESS: {
      return {
        ...state,
        loadOperation: false,
      };
    }
    case CHANGE_ROLE: {
      return {
        ...state,
        loadOperation: true,
      };
    }
    case CHANGE_ROLE_SUCCESS: {
      return {
        ...state,
        loadOperation: false,
      };
    }
    case CHANGE_MISSING_STATUS: {
      return {
        ...state,
        loadOperation: true,
      };
    }
    case CHANGE_MISSING_STATUS_SUCCESS: {
      return {
        ...state,
        loadOperation: false,
      };
    }
    case CHANGE_ETC_MISSING_STATUS: {
      return {
        ...state,
        loadOperation: true,
      };
    }
    case CHANGE_ETC_MISSING_STATUS_SUCCESS: {
      return {
        ...state,
        loadOperation: false,
      };
    }
    case GET_USER_SUCCESS: {
      if (action.payload.forceReresh === false) {
        return {
          ...state,
          //loader: false,
          users: [...state.users, ...action.payload.data],
        };
      } else {
        return {
          ...state,
          //loader: false,
          users: action.payload.data,
        };
      }
    }

    case GET_ADMIN_MISSING: {
      let adminMissings = state.adminMissings;
      if (action?.payload?.forceReresh) {
        adminMissings = [];
      }
      return {
        ...state,
        loader: true,
        adminMissings: adminMissings,
      };
    }

    case GET_ADMIN_MISSING_SUCCESS: {
      return {
        ...state,
        loader: false,
        adminMissings: action.payload,
      };
    }

    case GET_ETC_MISSING: {
      let adminEtcMissings = state.adminEtcMissings;
      if (action?.payload?.forceReresh) {
        adminEtcMissings = [];
      }

      return {
        ...state,
        loader: true,
        adminEtcMissings: adminEtcMissings,
      };
    }

    case GET_ETC_MISSING_SUCCESS: {
      return {
        ...state,
        loader: false,
        adminEtcMissings: action.payload,
      };
    }

    case GET_ADMIN_FOUND: {
      let adminFounds = state.adminFounds;
      if (action?.payload?.forceReresh) {
        adminFounds = [];
      }

      return {
        ...state,
        loader: true,
        adminFounds: adminFounds,
      };
    }

    case GET_ADMIN_FOUND_SUCCESS: {
      return {
        ...state,
        loader: false,
        adminFounds: action.payload,
      };
    }

    case GET_SETTING: {
      return {
        ...state,
        loader: true,
      };
    }

    case GET_SETTING_SUCCESS: {
      return {
        ...state,
        loader: false,
        setting: action.payload,
      };
    }

    case UPDATE_SETTING: {
      return {
        ...state,
        loader: true,
      };
    }

    case UPDATE_SETTING_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }

    case SHOW_ADMIN_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false,
      };
    }
    case HIDE_ADMIN_MESSAGE: {
      return {
        ...state,
        alertMessage: "",
        showMessage: false,
        loader: false,
      };
    }

    case ON_HIDE_ADMIN_LOADER: {
      return {
        ...state,
        loader: false,
      };
    }

    case DELETE_EVENT: {
      return {
        ...state,
        loader: true,
      };
    }
    case DELETE_EVENT_SUCEESS: {
      return {
        ...state,
        loader: false,
      };
    }
    case RESET_PASSWORD: {
      return {
        ...state,
        loader: true,
      };
    }
    case RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }
    case CHANGE_ADDRESS: {
      return {
        ...state,
        loader: true,
        changeAddressSuccess: false,
      };
    }
    case CHANGE_ADDRESS_SUCCESS: {
      return {
        ...state,
        loader: false,
        changeAddressSuccess: true,
      };
    }
    case ADMIN_REPORT: {
      return {
        ...state,
        loader: true,
      };
    }
    case ADMIN_REPORT_SUCEESS: {
      return {
        ...state,
        adminReport: action.payload,
        loader: false,
      };
    }
    case ADMIN_GET_MISSION_BY_ID: {
      return {
        ...state,
        getMissionLoader: true,
      };
    }
    case ADMIN_GET_MISSION_BY_ID_SUCCESS: {
      return {
        ...state,
        missionData: action.payload,
        getMissionLoader: false,
      };
    }

    case ON_UPDATE_Missing: {
      return {
        ...state,
        getMissionLoader: true,
      };
    }
    case ON_UPDATE_Missing_Success: {
      return {
        ...state,
        getMissionLoader: false,
      };
    }
    case ON_SHOW_ADMIN_LOADER: {
      return {
        ...state,
        loader: true,
      };
    }
    default:
      return state;
  }
};
